import { API_CLIENT, API_CLIENT_GET_AXIOS } from "../api_call/service_instances.js";

import {
	GET_INFO,
	GET_NJESIT,
	GET_FSHATRAT,
	GET_NJESITE_LAYERS,
	GET_NDERRMARJET,
	GET_KOPSHTET,
	GET_SHKOLLAT,
	GET_SHKOLLAT_COMUNITY,
	GET_ADRESS_LIVE_TRAFIC
} from "../url/urls_in_app.js";

/*
 * --------------------------------------------------------
 *  Contain all url and fuctions needed to make call to the application
 *  only for info part
 * --------------------------------------------------------
 */

export default {
	getInfo() {
		return API_CLIENT(GET_INFO);
	},

	getNjesite() {
		return API_CLIENT(GET_NJESIT);
	},

	getFshatrat() {
		return API_CLIENT(GET_FSHATRAT);
	},

	getNjesiteLayers() {
		return API_CLIENT(GET_NJESITE_LAYERS);
	},

	getNdermarrjet() {
		return API_CLIENT(GET_NDERRMARJET);
	},

	getKopshtet() {
		return API_CLIENT(GET_KOPSHTET);
	},

	getShkollat(lng) {
		return API_CLIENT(GET_SHKOLLAT + lng + "&category=arsimi");
	},

	getShkollatComunity() {
		return API_CLIENT(GET_SHKOLLAT_COMUNITY);
	},

	getAdressLiveTrafic(lat_lond) {
		return API_CLIENT_GET_AXIOS(GET_ADRESS_LIVE_TRAFIC + lat_lond);
	}
};
